import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { appendModel } from '../../../../features/site/siteSlice'
import { oauthConsts, OVERRIDE_ID_LINKEDIN } from '../../../utils/common'

const INITIAL_STATE = {
    account: {}
}

function LinkedInAds(props){

    const oauthConst = oauthConsts()

    const dispatch = useDispatch()
    const [state, setState] = useState(INITIAL_STATE)

    const model = useSelector(state => state.site.model)
    const isAdmin = useSelector(state => state.session.isAdmin)
    const oauthTokens = useSelector(state => state.session.oauthTokens)
    
    const AddAccParent = (p) => props.design === "onboarding" ? <div className="text-center">
        {p.children}
    </div> : <>{p.children}</>

    useEffect(() => {
        if(state.account !== INITIAL_STATE.account){

            let { account } = state 
            const map = {
                tokenId: oauthTokens.linkedin?.id,
                accountId: account.id,
                accountName: account.name,
                reference: account.reference,
                account: account.account,
                type: account.type
            }
            
            let sForm = {
                ...model.siteForm,
                attr: {
                    ...model.siteForm.attr,
                    accounts: {
                        ...(model.siteForm.attr.accounts ? model.siteForm.attr.accounts : []),
                        linkedin: map
                    }
                }
            }

            localStorage.setItem("linkedinSelection", JSON.stringify({
                account: account.id,
                accountKey: account.key,
                map: JSON.stringify({...map})
            }))

            dispatch(appendModel({siteForm: sForm}))

            props.onSelectionUpdated("linkedin")
        }
    }, [state.account])
    
    const { siteForm, sites, siteActiveIdx } = model
    const { account } = state

    const hrefOauth = `${oauthConst.linkedInAuthURL}&state=${props.design === "onboarding" ? "/onboarding/" : "/admin/"}${siteForm.siteId}/linkedin`
    const site = sites[siteActiveIdx]
    return <>
        {(!model.reseller || (model.reseller && !model.isAffiliate)) && (!siteForm?.attr?.accounts?.linkedin && oauthTokens?.linkedin) && <>
            <div className="d-flex justify-content-end mb-3">
                <div className="btn-group">
                    <a href={hrefOauth} className="btn btn-lg btn-info">
                        <i class="fas fa-sync-alt"></i> Refresh
                    </a>
                </div>
            </div>
            <form>
                <div class="form-group">
                    <label for="acct">Account</label>
                    <select id="linkedin-acct" className="form-control" onChange={(e) => setState(prev => ({...prev, account: {...oauthTokens?.linkedin?.accounts[e.target.value], key: e.target.value}}))} value={account?.key}>
                        <option></option>
                        {oauthTokens?.linkedin?.accounts?.map((acct, key) => <option key={key} value={key}>{acct.name}</option>)}
                    </select>
                </div>
            </form>
        </>}
        {siteForm?.attr?.accounts?.linkedin && <div>
            {(!model.reseller || (model.reseller && !model.isAffiliate)) && sessionStorage.getItem(OVERRIDE_ID_LINKEDIN) && <h5 className="alert alert-info">
                Click the Save button to complete the reset token process
            </h5>}
            {(!model.reseller || (model.reseller && !model.isAffiliate)) && <div className={`d-flex justify-content-${isAdmin && siteForm?.attr?.accounts?.linkedin.refreshRequired ? 'between' : 'end'} mb-3`}>
                {isAdmin && siteForm?.attr?.accounts?.linkedin.refreshRequired && <div class="alert alert-danger mb-0" role="alert">
                    <strong>Next Alert Date:</strong> {siteForm?.attr?.accounts?.linkedin.refreshAlertDate}
                </div>}
                <div className="btn-group">
                    {!sessionStorage.getItem(OVERRIDE_ID_LINKEDIN) && siteForm?.attr?.accounts?.linkedin?.refreshRequired && <button className="btn btn-lg btn-danger" onClick={() => props.onResetToken("linkedin", hrefOauth)}>
                        <i class="fas fa-trash-alt"></i> Reset Token
                    </button>}
                    {isAdmin && <button className="btn btn-lg btn-outline-danger" onClick={() => props.onDeleteService("linkedin")}>
                        <i class="fas fa-trash-alt"></i> Delete
                    </button>}
                </div>
            </div>}
            {isAdmin && <div className="d-flex justify-content-start">
                <i className="fas fa-id-badge mr-1 fa-1-5"></i>
                <strong className="mr-1">Token ID: </strong>
                <h5>{siteForm?.attr?.accounts?.linkedin?.tokenId}</h5>
            </div>}
            <h3>
                <small class="text-muted">Account:</small> <span id="linkedinAccountName">{siteForm.attr?.accounts?.linkedin?.accountName}</span>
            </h3>
        </div>}
        {(!model.reseller || (model.reseller && !model.isAffiliate)) && (!site?.attr?.accounts?.linkedin && !oauthTokens?.linkedin) && <AddAccParent>
            <a class="btn btn-success btn-lg" href={hrefOauth}>Add Account</a>
        </AddAccParent>}
    </>
}

LinkedInAds.defaultProps = {
    design: "admin",
    onSelectionUpdated: () => null
}

export default LinkedInAds